import { css } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';
import 'portal-base/src/components/ki-portal-base-timerange-selector/ki-portal-base-timerange-selector';

import KiDSGraph from 'ds-shared-lib/src/components/ki-ds-graph/ki-ds-graph';

import nls from '../../locales/indexes.nls';

const NAME = 'ki-ds-pwa-graph';

@i18n(nls)
@customElement(NAME)
export class KiDsPwaGraph extends KiDSGraph {
    static styles = [
        super.styles,
        css`
            .legend-bubble .functions-wrapper #edit {
                display: none;
            }
        `,
    ];

    _className = NAME;
}
